<section class="hero section__bg-gradient-parent">
  <div class="hero__overlay" aria-hidden="true"></div>
  <div class="hero__background" aria-hidden="true">
    <!-- Paints the hero before any JS runs, so this is the LCP element rather than the
         opener, which `lazyStrategy="idle"` deliberately holds back until after load. -->
    <picture>
      <source media="(max-width: 600px)" srcset="/assets/hero/opener-poster-sm.webp" />
      <img
        class="hero__poster"
        fill
        priority
        ngSrc="/assets/hero/opener-poster.webp"
        alt="Opener poster"
      />
    </picture>

    <app-video-player
      videoSrc="/assets/hero/opener.webm"
      [sources]="{ mobile: '/assets/hero/opener-sm.webm' }"
      lazyStrategy="idle"
    />
  </div>

  <div class="hero__inner container">
    <div class="hero__content">
      <div class="hero__text">
        <h1 class="hero__title heading">Which image are you turning into 3D today?</h1>
      </div>

      <div class="hero__cta">
        <p class="hero__subtitle subheading">
          EVRN is the directing layer for generative video. Upload a flat image, get a full 3D scene
          you can direct.
        </p>

        <app-button fullWidth [href]="`${environment.appUrl}/auth/register`"
          >Get started</app-button
        >
      </div>
    </div>
  </div>
</section>
